import { useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { DEFAULT_GEO_LOCATION, DEFAULT_MAP_ZOOM } from '../config/constant';
import { devicesActions } from '../store';
import { map } from './Map';

var flag = false;
const SelectedDeviceMap = (props) => {
  const { temporaryPage } = props;

  const dispatch = useDispatch();

  const user = useSelector((state) => state.session.user);
  const mapCenter = useSelector((state) => {
    if (state.devices.selectedId) {
      const position = state.devices.items[state.devices.selectedId] || null;
      if (position && position.id) {
        return { deviceId: state.devices.selectedId, position: [position.longitude, position.latitude] };
      } else {
        if (temporaryPage) {
          return null
        } else {
          return { deviceId: state.devices.selectedId, position: [DEFAULT_GEO_LOCATION[1], DEFAULT_GEO_LOCATION[0]] };
        }
      }
    }
    return null;
  });

  const selectedDeviceId = useSelector((state) => state.devices.selectedId);

  useEffect(() => {
    updateMapCenterPosition()
  }, [mapCenter, selectedDeviceId]);

  useEffect(() => {
    map.on('zoom', onZoomMap);
    return () => {
      map.off('zoom', onZoomMap);
    }
  }, []);
  const zoomMapWatcherStatus = useRef(false)
  const updateMapCenterPosition = () => {
    //console.log("mapCenter::::::", mapCenter)
    zoomMapWatcherStatus.current = false
    if (mapCenter) {
      var paddingBottom = 0
      if (selectedDeviceId) {
        paddingBottom = 560
      }

      const easeToOption = {
        center: mapCenter.position,
        padding: { bottom: paddingBottom }
      }

      easeToOption['zoom'] = DEFAULT_MAP_ZOOM

      if (user.id || !flag) map.easeTo({ ...easeToOption });
      flag = true;
      // map.easeTo({ center: mapCenter.position , zoom: 18 });

      //dispatch(devicesActions.unselect());
      setTimeout(function () {
        zoomMapWatcherStatus.current = true
      }, 1000)
    }
  }

  const lastZoomRef = useRef(map.getZoom());
  const onZoomMap = () => {
    const currentZoom = map.getZoom();
    const zoomModified = currentZoom !== lastZoomRef.current
    lastZoomRef.current = currentZoom;
    if (zoomModified) {
      if (zoomMapWatcherStatus.current) {
        dispatch(devicesActions.unselect());
      }
    }
  }

  return null;
};

export default SelectedDeviceMap;
